define.alias("shared/components/shared/ui/accordion", "media/components/shared/ui/accordion");